package io.horion.cv.pages.job.company

import androidx.compose.animation.core.animateDp
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.updateTransition
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.unit.dp
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.ApplyJobModal
import io.horion.cv.components.FilterContent
import io.horion.cv.components.FilterDrawer
import io.horion.cv.components.Footer
import io.horion.cv.components.JobActionBar
import io.horion.cv.components.JobDetailsModal
import io.horion.cv.components.Topbar
import io.horion.cv.components.cards.JobCardNew
import io.horion.cv.components.widgets.AlertMessage
import io.horion.cv.components.widgets.FilterCheckGroup
import io.horion.cv.components.widgets.LoadEffect
import io.horion.cv.components.widgets.PaginationControls
import io.horion.cv.components.widgets.ToastType
import io.horion.cv.components.widgets.useToast
import io.horion.cv.di.koinGet
import io.horion.cv.models.ExperienceLevel
import io.horion.cv.models.Job
import io.horion.cv.models.JobType
import io.horion.cv.styles.FormlocalisationStyle
import io.horion.cv.uiState.JobUiState
import io.horion.cv.utils.Colors
import io.horion.cv.utils.jobsList
import io.horion.cv.utils.label
import io.horion.cv.viewModel.JobViewModel
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input

@OptIn(DelicateApi::class)
@Page(routeOverride = "/job/recruteur")
@Composable
fun JobListePage() {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val viewModel = koinGet<JobViewModel>()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint<=Breakpoint.MD

    val state = viewModel.jobUiState
    var isUser by remember { mutableStateOf(false) }//ici true signifie qu'on est un usager quelconque, false signifie qu'on est une enterprise
    var showApplyModal by remember { mutableStateOf(false) }
    val toast = useToast()
    var hasApplied by remember { mutableStateOf(false) }

    // État pour la pagination
    var currentPage by remember { mutableStateOf(0) }
    val itemsPerPage = 10
    val allJobs = viewModel.filteredJobs()
    val totalPages = (allJobs.size + itemsPerPage - 1) / itemsPerPage
    val currentJobs = remember(currentPage, allJobs) {
        val start = currentPage * itemsPerPage
        val end = minOf(start + itemsPerPage, allJobs.size)
        allJobs.subList(start, end)
    }
    LaunchedEffect(Unit) {
        viewModel.loadAllJobs()
    }
    // Effet pour fermer les deux modals après la soumission
    LaunchedEffect(hasApplied) {
        if (hasApplied) {
            showApplyModal = false
            viewModel.closeJobDetails()
            delay(500)
            hasApplied = false
        }
    }

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Topbar()
            JobActionBar(
                isUser = isUser, isMobile = isMobile, isDark = isDark
            )
            JobsContent(
                breakpoint = breakpoint,
                viewModel = viewModel,
                isUser = isUser,
                currentJobs = currentJobs,
                currentPage = currentPage,
                totalPages = totalPages,
                onPageChange = { newPage ->
                    currentPage = newPage
                },
                isDark = isDark
            )
            Footer()
        }
        if (state.selectedJob != null && !hasApplied) {
            JobDetailsModal(
                job = state.selectedJob,
                onDismiss = { viewModel.closeJobDetails() },
                breakpoint = breakpoint,
                isUser = isUser,
                onClick = { showApplyModal = true },
                isDark = isDark
            )
        }

        //SI L'UTILISATEUR EST CONNECTE IL POURRA POSTULER
        if (showApplyModal && !hasApplied) {
            ApplyJobModal(
                onDismiss = { showApplyModal = false },
                onClick = {
                    toast.show(
                        "Candidature envoyée avec succès !",
                        ToastType.SUCCESS,
                        3000
                    )
                    hasApplied = true
                }
            )
        }
        AlertMessage(
            message = toast.message,
            isVisible = toast.isVisible,
            onDismiss = toast.hide,
            type = toast.type
        )
        FloatingEnterpriseBadge(
            enterpriseName = "Nom de l'enterprise"
        )
    }
}

@Composable
fun JobsContent(
    isUser: Boolean,
    breakpoint: Breakpoint,
    viewModel: JobViewModel,
    currentJobs: List<Job>,
    currentPage: Int,
    totalPages: Int,
    onPageChange: (Int) -> Unit,
    isDark : Boolean
) {
    val ctx = rememberPageContext()
    val state = viewModel.jobUiState

    var showFilterModal by remember { mutableStateOf(false) }


    // Déterminer si on est sur petit écran
    val isSmallScreen = breakpoint <= Breakpoint.SM

    if (isSmallScreen) {
        // SI ON EST SUR PETIT ECRAN,on ne vois que les postes , pour filtrer on clique sur le bouton filtre
        Box(modifier = Modifier.fillMaxSize()) {
            // Contenu principal : liste des offres
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .backgroundColor(if (isDark) Colors.BlackLight else Colors.LightGray)
                    .padding(10.px)
            ) {
                Box(
                    modifier = Modifier
                        .backgroundColor(if (isDark) Colors.holder else Colors.White)
                        .borderRadius(12.px)
                        .padding(15.px)
                ) {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        // Bouton filtre flottant en haut à droite
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .margin(bottom = 10.px),
                            contentAlignment = Alignment.CenterEnd
                        ) {
                            Button(
                                onClick = { showFilterModal = true },
                                modifier = Modifier
                                    .backgroundColor(Colors.Primary)
                                    .borderRadius(8.px)
                                    .padding(leftRight = 16.px, topBottom = 8.px)
                            ) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.spacedBy(8.px)
                                ) {
                                    SpanText(
                                        "Filtrer",
                                        modifier = Modifier.fontSize(14.px)
                                            .color(if (isDark) Colors.Black else Colors.White)
                                    )

                                }
                            }
                        }

                        // Liste des jobs
                        Column(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            jobsList.forEach { job ->
                                JobCardNew(
                                    isUser = isUser,
                                    job = job,
                                    isOpen = state.selectedJob?.id == job.id,
                                    breakpoint = breakpoint,
                                    onClick = {
                                        if (state.selectedJob?.id == job.id) {
                                            viewModel.clearSelectedJob()
                                        } else {
                                            viewModel.selectJob(job)
                                        }
                                    },
                                    isDark = isDark
                                )
                            }
                            when {
                                state.loading -> {
                                    LoadEffect()
                                    SpanText(
                                        "Chargement des offres...",
                                        modifier = Modifier
                                            .fontSize(16.px)
                                            .color(if (isDark) Colors.White else Colors.Graytext)
                                            .margin(top = 30.px)
                                    )
                                }

                                !state.isConnected -> {
                                    SpanText(
                                        "Pas de connexion. Vérifiez votre réseau.",
                                        modifier = Modifier
                                            .fontSize(16.px)
                                            .color(if (isDark) Colors.White else Colors.Graytext)
                                            .margin(top = 30.px)
                                    )
                                }

                                state.error != null -> {
                                    SpanText(
                                        state.error,
                                        modifier = Modifier
                                            .fontSize(16.px)
                                            .color(if (isDark) Colors.White else Colors.Graytext)
                                            .margin(top = 30.px)
                                    )
                                }

                                viewModel.filteredJobs().isEmpty() -> {
                                    SpanText(
                                        "Aucune offre ne correspond à vos critères.",
                                        modifier = Modifier
                                            .fontSize(16.px)
                                            .color(if (isDark) Colors.White else Colors.Graytext)
                                            .margin(top = 30.px)
                                    )
                                }

                                else -> {
                                    /*viewModel.filteredJobs().forEach { job ->
                                        JobCardNew(
                                            isUser = isUser,
                                            job = job,
                                            isOpen = state.selectedJob?.id == job.id,
                                            breakpoint = breakpoint,
                                            onClick = {
                                                if (state.selectedJob?.id == job.id) {
                                                    viewModel.clearSelectedJob()
                                                } else {
                                                    viewModel.selectJob(job)
                                                    ctx.router.navigateTo("/job/details")
                                                }
                                            },
                                            isDark = isDark
                                        )
                                    }*/

                                    // Affiche les jobs de la page courante
                                    currentJobs.forEach { job ->
                                        JobCardNew(
                                            isUser = isUser,
                                            job = job,
                                            isOpen = state.selectedJob?.id == job.id,
                                            breakpoint = breakpoint,
                                            onClick = {
                                                if (state.selectedJob?.id == job.id) {
                                                    viewModel.clearSelectedJob()
                                                } else {
                                                    viewModel.selectJob(job)
                                                    ctx.router.navigateTo("/job/details")
                                                }
                                            },
                                            isDark = isDark
                                        )
                                    }

                                    // Ajoute la pagination
                                    if (totalPages > 1) {
                                        Box(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .margin(top = 20.px, bottom = 10.px),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            PaginationControls(
                                                currentPage = currentPage,
                                                totalPages = totalPages,
                                                onPageChange = onPageChange,
                                                isMobile = false
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Modal de filtre (Drawer depuis la droite)
            if (showFilterModal) {
                FilterDrawer(
                    isVisible = showFilterModal,
                    onDismiss = { showFilterModal = false },
                    state = state,
                    viewModel = viewModel,
                    breakpoint = breakpoint,
                    isDark = isDark
                )
            }
        }
    }
    //SI ON EST SUR GRAND ECRAN
    else {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(10.px)
                .backgroundColor(if (isDark) Colors.BlackLight else Colors.LightGray),
            horizontalArrangement = Arrangement.spacedBy(10.px),
            verticalAlignment = Alignment.Top
        ) {
// ── BOX GAUCHE : offres ───────────────────────────────────────────────
            Box(
                modifier = Modifier
                    .backgroundColor(if (isDark) Colors.DarkBG else Colors.White)
                    .flexGrow(3)
                    .borderRadius(12.px)
                    .padding(15.px)
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    jobsList.forEach { job ->
                        JobCardNew(
                            isUser = isUser,
                            job = job,
                            isOpen = state.selectedJob?.id == job.id,
                            breakpoint = breakpoint,
                            onClick = {
                                if (state.selectedJob?.id == job.id) {
                                    viewModel.clearSelectedJob()
                                } else {
                                    viewModel.selectJob(job)
                                }
                            },
                            isDark = isDark
                        )
                    }
                    when {
                        state.loading -> {
                            LoadEffect()
                            SpanText(
                                "Chargement des offres...",
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                                    .margin(top = 30.px)
                            )
                        }

                        !state.isConnected -> {
                            SpanText(
                                "Pas de connexion. Vérifiez votre réseau.",
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                                    .margin(top = 30.px)
                            )
                        }

                        state.error != null -> {
                            SpanText(
                                state.error,
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                                    .margin(top = 30.px)
                            )
                        }

                        viewModel.filteredJobs().isEmpty() -> {
                            SpanText(
                                "Aucune offre ne correspond à vos critères.",
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                                    .margin(top = 30.px)
                            )
                        }

                        else -> {
                            /*viewModel.filteredJobs().forEach { job ->
                                JobCardNew(
                                    isUser = isUser,
                                    job = job,
                                    isOpen = state.selectedJob?.id == job.id,
                                    breakpoint = breakpoint,
                                    onClick = {
                                        if (state.selectedJob?.id == job.id) {
                                            viewModel.clearSelectedJob()
                                        } else {
                                            viewModel.selectJob(job)
                                            ctx.router.navigateTo("/job/details")
                                        }
                                    },
                                    isDark = isDark
                                )
                            }*/

                            // Affiche les jobs de la page courante
                            currentJobs.forEach { job ->
                                JobCardNew(
                                    isUser = isUser,
                                    job = job,
                                    isOpen = state.selectedJob?.id == job.id,
                                    breakpoint = breakpoint,
                                    onClick = {
                                        if (state.selectedJob?.id == job.id) {
                                            viewModel.clearSelectedJob()
                                        } else {
                                            viewModel.selectJob(job)
                                        }
                                    },
                                    isDark = isDark
                                )
                            }

                            // Ajoute la pagination
                            if (totalPages > 1) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .margin(top = 20.px, bottom = 10.px),
                                    contentAlignment = Alignment.Center
                                ) {
                                    PaginationControls(
                                        currentPage = currentPage,
                                        totalPages = totalPages,
                                        onPageChange = onPageChange,
                                        isMobile = false
                                    )
                                }
                            }
                        }
                    }
                }
            }

            // ── BOX DROITE : filtres ──────────────────────────────────────────────
            Box(
                modifier = Modifier
                    .backgroundColor(if (isDark) Colors.Primary else Colors.White)
                    .width(300.px)
                    .flexGrow(1)
                    .position(Position.Sticky)
                    .top(80.px)
                    .borderRadius(12.px)
                    .padding(15.px)
            ) {
                FilterContent(
                    state = state,
                    viewModel = viewModel,
                    breakpoint = breakpoint
                )
            }
        }
    }
}

@Composable
fun FloatingEnterpriseBadge(
    enterpriseName: String
) {

    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(40.px)
            .left(20.px)
            .zIndex(9999)

            // style du composant
            .backgroundColor(Colors.White)
            .borderRadius(16.px)
            .padding(leftRight = 18.px, topBottom = 12.px)

            // ombre pour effet modal/flottant
            .styleModifier {
                property("box-shadow", "0 8px 30px rgba(0,0,0,0.18)")
                property("backdrop-filter", "blur(8px)")
            }
    ) {

        SpanText(
            text = enterpriseName,
            modifier = Modifier
                .fontSize(16.px)
                .fontWeight(FontWeight.Bold)
                .color(Colors.Black)
        )
    }
}